// https://github.com/giantcz/gia
// Add import to js/components
import Component from 'gia/Component'
import { CountUp } from 'countup.js'

export default class CountUpComponent extends Component {
  
  constructor(element) {
    super(element);
    this.ref = {}
    this.content = this.element.innerText.replace(/\D/g, '') * 1;
    this.counter = new CountUp(this.element, this.content);
  }
  
  mount() {

    const observer = new IntersectionObserver((entries) => {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          //start count
          this.counter.start();
          observer.unobserve(this.element);
        }
        // else {
        //   //reset count
        //   this.counter.reset();
        // }
      });
    });
    observer.observe(this.element);
  }
  
  startCount() {
    CountUpComponent.counter.start();
  }
  resetCount() {
    CountUpComponent.counter.reset();
  }
  
}